import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsFieldsAssociateRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-fields-associate',
	path: '/secure/admin/SelectFieldLayoutScheme!default.jspa',
};
